import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AdminService } from '../../services/admin.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-league-dialog',
  templateUrl: './league-dialog.component.html',
  styleUrls: ['./league-dialog.component.scss'],
})
export class LeagueDialogComponent implements OnInit {
  leagueForm: FormGroup;
  isEditMode = false;
  topLevelCategories: any[] = [];

  constructor(
    private fb: FormBuilder,
    private adminService: AdminService,
    public dialogRef: MatDialogRef<LeagueDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.isEditMode = !!data.league;

    this.leagueForm = this.fb.group({
      name: [data.league ? data.league.name : '', Validators.required],
      numberOfTeams: [data.league ? data.league.numberOfTeams : '', Validators.required],
      totalGameWeeks: [data.league ? data.league.totalGameWeeks : '', Validators.required],
    });
  }

  ngOnInit(): void {
    this.adminService.getAllCategoriesWithTopLevel().subscribe((categories) => {
      this.topLevelCategories = categories;
    });
  }

  onSave(): void {
    if (this.leagueForm.valid) {
      let leagueData = this.leagueForm.value;

      const findCategoryByName = (categories: any[], name: string): any => {
        for (let category of categories) {
          if (category.name === name) {
            return category;
          }
          if (category.subCategories && category.subCategories.length > 0) {
            const foundInSubCategory = findCategoryByName(category.subCategories, name);
            if (foundInSubCategory) {
              return foundInSubCategory;
            }
          }
        }
        return null;
      };

      const matchingCategory = findCategoryByName(this.topLevelCategories, leagueData.name);
      leagueData.leagueReferenceId = matchingCategory ? matchingCategory.id : null;

      if (this.isEditMode) {
        this.adminService.updateLeague(this.data.league.id, leagueData).subscribe(
          () => this.dialogRef.close(true),
          (error) => this.showSaveError(error)
        );
      } else {
        this.adminService.createLeague(leagueData).subscribe(
          () => this.dialogRef.close(true),
          (error) => this.showSaveError(error)
        );
      }
    }
  }

  private showSaveError(error: any): void {
    const message = error?.error?.message || 'An error occurred while saving the league.';
    Swal.fire('Error', message, 'error');
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  getDialogTitle(): string {
    return this.isEditMode ? 'Edit League' : 'Create League';
  }

  getCreateOrUpdate(): string {
    return this.isEditMode ? 'Update' : 'Create';
  }
}
